var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M6.25 5h5l2.5 6.25-3.125 1.875a13.75 13.75 0 0 0 6.25 6.25l1.875-3.125 6.25 2.5v5a2.5 2.5 0 0 1-2.5 2.5A20 20 0 0 1 3.75 7.5 2.5 2.5 0 0 1 6.25 5"
  })));
};
export default SvgPhone;